import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { loadStripe } from '@stripe/stripe-js';
import { PaymentScreenComponent } from './PaymentScreenComponent';
import stores from '../../../../stores';
import { Results } from '../constants';

class PaymentScreenContainerClassComponent extends Component {
  constructor() {
    super();

    this.state = {
      isPaymentFormShown: false,
      stripePromise: null,
      isMounted: false,
    };
  }

  componentDidMount = () => {
    this.setState({ isMounted: true });
    stores.userStore.getUser();
  };

  togglePaymentForm = async () => {
    const { setResult, schoolId, setSent } = this.props;
    const { isPaymentFormShown, stripePromise } = this.state;
    if (isPaymentFormShown) {
      this.setState({ isPaymentFormShown: false });
    } else {
      try {
        await stores.theoryAccessStore.getPaymentData(schoolId);
        if (!stripePromise) {
          const connectedStripeAccountId = stores.theoryAccessStore.paymentData.connected_stripe_account_id;
          const stripe = await loadStripe(process.env.STRIPE_PUBLISHABLE_KEY || 'pk_test_88WGpTtJOwCnESkYtgEebE33', { stripeAccount: connectedStripeAccountId });
          this.setState({ stripePromise: stripe });
        }
        this.setState({ isPaymentFormShown: true });
      } catch (e) {
        setSent(true);
        setResult(Results.Error);
      }
    }
  };

  render() {
    const {
      setResult, setSent, schoolName, cost, schoolId,
    } = this.props;
    const { userInfo, isUserBusy } = stores.userStore;
    const { isPaymentFormShown, stripePromise, isMounted } = this.state;

    return (
      <PaymentScreenComponent
        user={userInfo}
        isUserBusy={isUserBusy}
        isPaymentFormShown={isPaymentFormShown}
        togglePaymentForm={this.togglePaymentForm}
        setResult={setResult}
        setSent={setSent}
        schoolName={schoolName}
        cost={cost}
        schoolId={schoolId}
        stripePromise={stripePromise}
        isMounted={isMounted}
      />
    );
  }
}

PaymentScreenContainerClassComponent.propTypes = {
  setResult: PropTypes.func.isRequired,
  setSent: PropTypes.func.isRequired,
  schoolName: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
  schoolId: PropTypes.string.isRequired,
};

const PaymentScreenContainer = observer(PaymentScreenContainerClassComponent);

export { PaymentScreenContainer };
